import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { CreateEventPage } from './pages/CreateEventPage';
import { EventDetailPage } from './pages/EventDetailPage';
import { RespondPage } from './pages/RespondPage';
import { useEffect, useState } from 'react';

// Component to handle auth callback on root route
function AuthCallback() {
    const [searchParams] = useSearchParams();
    const { isLoading, isAuthenticated } = useAuth();
    const [isProcessing, setIsProcessing] = useState(false);

    const token = searchParams.get('token');
    const userid = searchParams.get('userid');

    useEffect(() => {
        if (token && userid && !isProcessing) {
            setIsProcessing(true);
            console.log('AuthCallback: Processing token...');

            fetch('/api/auth/callback', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ token, userid }),
            })
                .then(response => {
                    console.log('AuthCallback: Response status:', response.status);
                    if (response.ok) {
                        // Redirect to dashboard without the token params
                        window.location.href = '/dashboard';
                    } else {
                        window.location.href = '/login?error=auth_failed';
                    }
                })
                .catch(error => {
                    console.error('AuthCallback: Error:', error);
                    window.location.href = '/login?error=auth_error';
                });
        }
    }, [token, userid, isProcessing]);

    // If we have a token, show loading while processing
    if (token && userid) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
            }}>
                <div className="spinner" />
            </div>
        );
    }

    // No token - just redirect to dashboard (or login if not authenticated)
    if (isLoading) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
            }}>
                <div className="spinner" />
            </div>
        );
    }

    if (isAuthenticated) {
        return <Navigate to="/dashboard" replace />;
    }

    return <Navigate to="/login" replace />;
}

function App() {
    return (
        <AuthProvider>
            <Routes>
                {/* Public routes */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/respond/:token" element={<RespondPage />} />

                {/* Protected routes */}
                <Route element={<ProtectedRoute />}>
                    <Route element={<Layout />}>
                        <Route path="/dashboard" element={<DashboardPage />} />
                        <Route path="/events/new" element={<CreateEventPage />} />
                        <Route path="/events/:id" element={<EventDetailPage />} />
                        <Route path="/events/:id/edit" element={<CreateEventPage />} />
                    </Route>
                </Route>

                {/* Root route - handles auth callback */}
                <Route path="/" element={<AuthCallback />} />
            </Routes>
        </AuthProvider>
    );
}

export default App;

